import { useParams } from 'react-router'
import { Heading } from '@/components/base/heading'
// @ts-expect-error fragment is used in the query by fragment name
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Device, DeviceFragment } from '@/components/devices/device'
import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'

const DeviceQuery = graphql(`
  query Device($id: ID!) {
    devices(filters: { idEq: $id }) {
      nodes {
        id
        name
        ...DeviceDetail
      }
    }
  }
`)

export const Show = () => {
  const { id } = useParams() as { id: string }

  const { data, loading, error } = useQuery(DeviceQuery, { variables: { id } })

  if (loading) return <LoadingSkeleton table title />

  return (<div className="flex flex-col gap-3 grow">
    { error && <Error error={ error } /> }
    { data && <>
      <Heading level={ 1 } size="3xl">{ data.devices.nodes[0].name }</Heading>
      <Device id={ id } />
    </> }
  </div>)
}
